var map = {
	"./bank-card.svg": 286,
	"./billingHistory.svg": 619,
	"./building.svg": 287,
	"./buildingIcon.svg": 620,
	"./camera-green.svg": 621,
	"./close-white.svg": 622,
	"./closeGreen.svg": 128,
	"./delete.svg": 623,
	"./home.svg": 624,
	"./iconClock.svg": 288,
	"./iconClockActive.svg": 625,
	"./iconClose.svg": 626,
	"./iconDown.svg": 627,
	"./iconDownBlack.svg": 628,
	"./iconDropdown.svg": 152,
	"./iconEdit.svg": 629,
	"./iconLeft.svg": 289,
	"./iconListToken1.svg": 630,
	"./iconListToken2.svg": 631,
	"./iconListToken3.svg": 632,
	"./iconListToken4.svg": 633,
	"./iconListToken5.svg": 634,
	"./iconListToken6.svg": 635,
	"./iconListToken7.svg": 636,
	"./iconShare.svg": 192,
	"./iconWallet.svg": 290,
	"./iconWorld.svg": 291,
	"./info.svg": 637,
	"./kiteGray.svg": 292,
	"./kiteWhite.svg": 293,
	"./loading-green.svg": 638,
	"./lock.svg": 639,
	"./logout-gray.svg": 285,
	"./logout.svg": 294,
	"./mail.svg": 640,
	"./mailGray.svg": 641,
	"./mailOval.svg": 295,
	"./pass.svg": 642,
	"./paymentHistory.svg": 643,
	"./pen-icon.svg": 644,
	"./person.svg": 645,
	"./phone.svg": 646,
	"./phoneOVal.svg": 296,
	"./requestingRefund.svg": 647,
	"./save.svg": 648,
	"./saveClipboard.svg": 649,
	"./shop.svg": 650,
	"./successGreen.svg": 153,
	"./trash.svg": 651,
	"./user.svg": 652,
	"./yenRecycled.svg": 653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;